import React from 'react';
import PropTypes from 'prop-types';
import Mosvita from '../../ui/typography/mosvita';
import {
  TestimonialsCardContainer,
  CardContainer,
  ImageProfile,
  CommentContainer,
  BodyContainer,
  CardDecoration,
  CardDetails
} from './style';
import { HtmlRaw } from '../../components';

const TestimonialsCard = ({ data, type }) => {
  const { image, personal_data, job_title, body } = data;

  return (
    <TestimonialsCardContainer>
      <CardContainer>
        <CardDetails cardType={type}>
          <ImageProfile src={image?.url} alt="Profile photo" />
          <BodyContainer>
            <CommentContainer>
              <Mosvita type="cardDescription">
                <HtmlRaw html={body} />
              </Mosvita>
            </CommentContainer>
            <Mosvita type="cardTestifier">{personal_data}</Mosvita>
            <Mosvita type="cardTask">{job_title}</Mosvita>
          </BodyContainer>
        </CardDetails>
        {type === TestimonialsCard.TYPE.TERTIARY && <CardDecoration />}
      </CardContainer>
    </TestimonialsCardContainer>
  );
};

TestimonialsCard.TYPE = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary'
};

TestimonialsCard.propTypes = {
  data: PropTypes.object,
  type: PropTypes.string
};

TestimonialsCard.defaultProps = {
  type: TestimonialsCard.TYPE.PRIMARY
};

export default TestimonialsCard;
